import React, { useContext, useEffect } from "react";
import { InstitutionalContext } from "../../context/InstitutionalContext";

function ShippingAndReturns() {
    const { institutionals, fetchInstitutional } = useContext(InstitutionalContext);
    
    useEffect(() => {
        const shippingCategory = "teslimat-ve-iade";
        if (!institutionals?.sef || institutionals.sef !== shippingCategory) {
            fetchInstitutional(shippingCategory);
        }
    }, [institutionals?.sef, fetchInstitutional]);
    
    return ( 
        <> 
              <div className='tab-pane'>
                <h4>Teslimat & İade Koşulları</h4>
                {institutionals?.aciklama ? (
                  <div dangerouslySetInnerHTML={{ __html: institutionals.aciklama }} />
                ) : (
                  <p>Yükleniyor...</p>
                )}
              </div>
        </>
     );
}

export default ShippingAndReturns;